export default __webpack_public_path__ + "static/media/installation_edge.ea83b895.png";